import { cloneElement, isValidElement, ReactNode } from 'react'
import styles from './KeywordChip.module.css'

// A keyword laid over a picture of the product, naming a feature you can see in it (Opera Neon's
// labels). A pixl icon in a square, then the word. The tone switches between the lv steps, as the
// pictograms do: no colour of its own.
export default function KeywordChip({ icon, children, tone = 'light', className, style }: {
  icon: ReactNode
  children: ReactNode
  tone?: 'light' | 'mid' | 'ink'
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <span className={`${styles.chip} ${styles[tone]} ${className ?? ''}`} style={style}>
      {/* pixl icons draw in their own ink unless told otherwise: here they take the chip's. */}
      <span className={styles.icon} aria-hidden="true">{isValidElement(icon) ? cloneElement(icon as React.ReactElement<{ color?: string }>, { color: 'currentColor' }) : icon}</span>
      {children}
    </span>
  )
}
